import { useEffect, useRef, useState } from "react";

import { eventHandler } from "dbl-utils";
// NOTE: @dblimp/core es la evolución de dbl-components, reescrito en TypeScript.
// Usamos BrowserRouterSchema para el enrutamiento basado en JSON schemas.
import { BrowserRouterSchema as Router } from "@dblimp/core";

import appCtrl from "./app-ctrl";

function App() {
  const [assetsLoadedTick, setAssetsLoadedTick] = useState(0);
  const subscriptionId = useRef<string>();

  if (!subscriptionId.current) {
    subscriptionId.current = `App.assetsLoaded.${Math.random()
      .toString(36)
      .slice(2)}`;
  }

  useEffect(() => {
    const handleAssetsLoaded = () => setAssetsLoadedTick((tick) => tick + 1);
    const id = subscriptionId.current!;

    eventHandler.subscribe("assetsLoaded", handleAssetsLoaded, id);

    return () => {
      eventHandler.unsubscribe("assetsLoaded", id);
    };
  }, [subscriptionId]);

  return (
    <Router
      key={assetsLoadedTick}
      routes={appCtrl.rootSchema!}
      test={false}
      forceRebuild={true}
    />
  );
}

export default App;
